import React, { useRef, useState, useEffect } from 'react';
import { Menu } from '@mui/material';
import { FilterIcon } from '@components/icons/svg-icon.tsx';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

interface Range {
  startDate: Date;
  endDate: Date;
  key: string;
}

const TableDateRangeFilter: React.FC<{
  columnId: string;
  onFilterChange: (columnId: string, value: [Date | null, Date | null]) => void;
  clearDateRangeFilters?: (columnId: string) => void;
  currentRange: [Date | null, Date | null] | null;
}> = ({ columnId, onFilterChange, clearDateRangeFilters, currentRange }) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const today = new Date();

  const initialRange: Range[] = [
    {
      startDate: currentRange?.[0] ?? today,
      endDate: currentRange?.[1] ?? today,
      key: 'selection'
    }
  ];

  const [range, setRange] = useState<Range[]>(initialRange);

  useEffect(() => {
    setRange([
      {
        startDate: currentRange?.[0] ?? today,
        endDate: currentRange?.[1] ?? today,
        key: 'selection'
      }
    ]);
  }, [currentRange]);

  const handleClick = () => {
    if (buttonRef.current) {
      setAnchorEl(buttonRef.current);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isSameDay = (date1: Date, date2: Date) =>
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear();

  const handleDateChange = (item: any) => {
    const { startDate, endDate } = item.selection;
    setRange([item.selection]);

    if (startDate && endDate && !isSameDay(startDate, endDate)) {
      onFilterChange(columnId, [startDate, endDate]);
      handleClose();
    }
  };

  const handleClear = () => {
    clearDateRangeFilters?.(columnId);
    handleClose();
  };

  return (
    <div>
      <button ref={buttonRef} onClick={handleClick}>
        <FilterIcon className="!w-[18px] !h-[18px] filter-icon-hover max-lg-xl:!w-[16px] max-lg-xl:!h-[16px]" />
      </button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        slotProps={{
          paper: {
            sx: {
              px: '20px !important'
            }
          }
        }}
      >
        <DateRange
          editableDateInputs={true}
          onChange={handleDateChange}
          moveRangeOnFirstSelection={false}
          ranges={range}
          months={2}
          direction="horizontal"
          dateDisplayFormat="dd/MM/yyyy"
          rangeColors={['var(--primary)']}
        />

        <div className="w-full flex justify-end py-2">
          <button
            onClick={handleClear}
            className="cursor-pointer text-[var(--primary)] font-medium pr-6"
          >
            Clear
          </button>
        </div>
      </Menu>
    </div>
  );
};

export default TableDateRangeFilter;
